import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { VisaDesignerService } from '../visa-designer.service';
import { IMMIGRANT_FORMS } from 'app-models';
import { Store } from '@ngrx/store';
import * as fromVDTask from '../vd-state/reducers/vd.reducer';
import * as vdTask from './../vd-state/actions/vd.actions';

@Component({
  selector: 'app-vd-builder-steps-navigator',
  templateUrl: './vd-builder-steps-navigator.component.html',
  styleUrls: ['./vd-builder-steps-navigator.component.scss']
})
export class VdBuilderStepsNavigatorComponent implements OnInit, OnDestroy {
  index = 0;
  stepsList: any[];
  visaId: any;
  visaInfo: any;
  observableSubscription$ = new Subject();
  immigrantForms: string[];
  buildType: string;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private vdService: VisaDesignerService,
    private store: Store<any>
  ) { }

  ngOnInit(): void {
    this.store.select(fromVDTask.getVDBuildType).pipe(take(1)).subscribe(formVDState => {
      this.buildType = formVDState;
      switch (this.buildType) {
        case 'pdf':
          this.stepsList = ['Task Details', 'Upload PDF', 'JSON Viewer', 'Build Steps', 'Timeline Steps', 'Form Mapping', 'Generate Letters', 'Review Summary'];
          break;
        case 'build':
        case 'old':
          this.stepsList = ['Task Details', 'Timeline Steps', 'Form Mapping', 'Generate Letters', 'Review Summary'];
          break;
        default:
          this.router.navigate(['../../../manage-visa/created-visas'], { relativeTo: this.route });
          break;
      }
    });
    this.immigrantForms = IMMIGRANT_FORMS;
    this.route.params
      .subscribe((params) => {
        this.visaId = params['id'];
        this.getVisaInfo(this.visaId);
      });
    this.router.events
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((e) => {

        if (e instanceof NavigationEnd) {
          if (e.url.indexOf('task-details') !== -1) {
            this.index = 0;
          } else if (e.url.indexOf('upload-pdf') !== -1) {
            this.index = 1;
          } else if (e.url.indexOf('json-viewer') !== -1) {
            this.index = 2;
          } else if (e.url.indexOf('build-steps') !== -1) {
            this.index = 3;
          } else if (e.url.indexOf('timeline-steps') !== -1) {
            this.index = this.buildType === 'pdf' ? 4 : 1;
          } else if (e.url.indexOf('timeline-create-steps') !== -1) {
            this.index = this.buildType === 'pdf' ? 4 : 1;
          } else if (e.url.indexOf('form-mapping') !== -1) {
            this.index = this.buildType === 'pdf' ? 5 : 2;
          } else if (e.url.indexOf('generate-letters') !== -1) {
            this.index = this.buildType === 'pdf' ? 6 : 3;
          } else if (e.url.indexOf('review') !== -1) {
            this.index = this.buildType === 'pdf' ? 7 : 4;
          } else {
            this.index = 0;
          }
        }
      });
  }

  getVisaInfo(visaId) {
    this.vdService.getVisaById(visaId).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
      localStorage.setItem('visaId', response.data.visaId);
      this.visaInfo = response.data ? response.data : null;
      if (this.visaInfo) {
        this.store.dispatch(new vdTask.SetVDVisaId(this.visaInfo.visaId));
        this.store.dispatch(new vdTask.SetVDVisaInfo(this.visaInfo));
        this.vdService.getVisaInfo.next(this.visaInfo);
      }


    });
  }
  handleChange(e) {
    this.index = e.index;
    if (this.index >= 0) {
      switch (this.stepsList[this.index]) {
        case 'Task Details':
          this.router.navigate([`./task-details`], { queryParams: { id: this.visaId }, relativeTo: this.route });
          break;
        case 'Timeline Steps':
          this.router.navigate(['./timeline-steps'], { queryParams: { id: this.visaId }, relativeTo: this.route });
          // this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[localStorage.getItem('userTypeRole')]}/visa-designer/visa-builder/visa-details-steps/${this.visaId}/timeline-steps`], { queryParams: { id: this.visaId } });
          break;
        case 'Generate Letters':
          this.router.navigate([`./generate-letters`], { relativeTo: this.route });
          break;
        case 'Review Summary':
          this.router.navigate([`./review`], { queryParams: { id: this.visaId }, relativeTo: this.route });
          break;
        case 'Timeline Steps':
          this.router.navigate([`./timeline-create-steps`], { queryParams: { id: this.visaId }, relativeTo: this.route });
          break;
        case 'Form Mapping':
          this.router.navigate([`./form-mapping`], { queryParams: { id: this.visaId }, relativeTo: this.route });
          break;
        // default:
        //   this.router.navigate([`./task-details`], { queryParams: { id: this.visaId }, relativeTo: this.route });
        //   break;
        // default:
        //   this.router.navigate([`./task-details`], { queryParams: { id: this.visaId }, relativeTo: this.route });
        //   break;
        case 'Upload PDF':
          this.router.navigate([`./upload-pdf`], { relativeTo: this.route });
          break;
        case 'Build Steps':
          this.router.navigate([`./build-steps`], { queryParams: { id: this.visaId }, relativeTo: this.route });
          break;
        case 'JSON Viewer':
          this.router.navigate([`./json-viewer`], { relativeTo: this.route });
          break;
      }
    } else {
      this.router.navigate([`./task-details`], { queryParams: { id: this.visaId }, relativeTo: this.route });
    }
  }

  ngOnDestroy() {
    this.store.dispatch(new vdTask.SetVDVisaId(null));
    this.store.dispatch(new vdTask.SetVDVisaInfo(null));
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }
}
